<template>
  <div
    :class="!withContainerCol ? '' : 'col-md-2 px-1' + (isSectionHidden ? '' : ' cs-hide-section')"
    class="popular-tags-section-container product-order-2"
  >
    <header class="header-section mb-1">
      <h2 class="middle-header-text text-center me-2 d-inline-block">
        Browse Options
      </h2>
    </header>

    <h6 class="sub-title text-uppercase text-start">
      POPULAR TAGS
    </h6>
    <ul class="popular-tags">
      <li
        v-for="popularTag in popularTagItems"
        :key="popularTag.id"
      >
        {{ popularTag.name }}
      </li>
    </ul>
    <div class="action-buttons d-flex flex-column">
      <p-button
        class="py-3 my-3"
        @click="onShopByGalleryBtnClicked"
      >
        shop by gallery
      </p-button>
      <p-button
        class="py-3 my-3 px-0"
      >
        PREBOOK AW21 NOW
      </p-button>
      <a
        class="mt-1"
        href="#"
      >SPECIAL PROGRAMS</a>
    </div>

    <div class="row filter-section cs-hide-on-md">
      <p-button
        class="filter-search-button"
        v-on="$listeners"
        @click="onSearchClicked"
      >
        <img
          src="../../../../public/img/icons/arrow-up.png"
          alt=""
          class="btn-icon"
        >
        FILTER SEARCH
      </p-button>
    </div>
  </div>
</template>

<script>
import PButton from '~/components/core/PButton'
import { mapGetters } from 'vuex'
import { EventBus } from '~/helpers/miscs'

export default {
  name: 'PopularTagsSection',
  components: { PButton },
  props: {
    withContainerCol: {
      type: Boolean,
      default: true
    },
    isSectionHidden: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters({
      commonMenu: 'menus/commonMenu'
    }),
    popularTagItems () {
      return this.commonMenu?.popular_tags
    }
  },
  methods: {
    onShopByGalleryBtnClicked () {
      EventBus.$emit('close-product-popper')
      this.$router.push({ name: 'shop-by-gallery' })
    },
    onSearchClicked () {
      this.$emit('toggleSection')
    },
  }
}
</script>

<style lang="scss" scoped>
.popular-tags-section-container {
  position: relative;
  border-left: 1px solid #B8B7B8; 
  border-right: 1px solid #B8B7B8;
    .sub-title:hover {
        font-style: italic;
        text-decoration: underline;
    }
    .sub-title {
      padding-top: 2px;
      margin-bottom: 1px;
    }
}
.filter-section {
  width: 100%;
  display: none;
  justify-content: center;
}
@media only screen and (max-width: 1280px) {
  .col-md-2 {
    width: 30% !important;
  }
  .popular-tags-section-container {
    border-right: 0;
  }
  .product-order-2 {
    order: 2;
  }
  .filter-section {
    display: flex;
    position: absolute;
    bottom: 9px;
    margin-left: 0px;
  }
}
.filter-search-button {
  width: 158px;
  height: 52px;
  background-color: #E3E2E2 !important;
  padding: 5px 16px;
  display: block;
  margin: auto;
  border: 0 !important;
  color: #383838 !important;
  .btn-icon {
    width: 20px;
    height: 20px;
    display: block;
    margin: auto;
  }
}
.action-buttons {
  .p-btn {
    padding: 0px;
  }
}
@media (max-width: 700px) {
  .col-md-2 {
    width: 50% !important;
  }
  // Filter button is pinned (absolute) over this column at mobile widths —
  // reserve space so it doesn't cover the action links underneath it.
  .popular-tags-section-container {
    padding-bottom: 70px;
  }
}
@media screen and (min-width:700px) {
  .cs-hide-on-md {
    display: none;
  }
}
@media screen and (max-width:1280px) and (min-width: 700px) {
  .cs-hide-section {
    display: none;
  }
}
</style>
